import { ScaleLinear } from 'd3-scale';
import omitUndefined from 'utils/omitUndefined';
import { getY, adjustYsForOverlap } from 'utils/svgUtils';
import { TooltipText } from 'utils/components/Tooltip/Tooltip';
import styleConstants from '../variables.module.scss';
import { YAxisLabelProps } from './YAxisLabel';

const LABEL_RECT_HEIGHT = parseInt(styleConstants.labelRectHeight);

interface ChartLabelData {
    key: string;
    type: string;
    tooltip: TooltipText;
    value: number | undefined;
    displayValue?: number | undefined;
}

export function deriveYAxisLabelProps(
    labelData: ChartLabelData[],
    formatFn: (val: number) => string,
    yScale: ScaleLinear<number, number>,
    height: number,
    width: number,
    valueSuffix = ''
): Record<string, YAxisLabelProps> {
    const labelsYMap = labelData.reduce(
        (res, label) => ({
            ...res,
            [label.key]: getY(yScale, height, LABEL_RECT_HEIGHT, label.value),
        }),
        {}
    );

    const adjusted = adjustYsForOverlap(
        omitUndefined(labelsYMap),
        height,
        LABEL_RECT_HEIGHT
    );

    return labelData.reduce(
        (res, label) => ({
            ...res,
            [label.key]:
                label.value !== undefined && adjusted[label.key] !== undefined
                    ? {
                          type: label.type,
                          value:
                              formatFn(
                                  label.displayValue !== undefined
                                      ? label.displayValue
                                      : label.value
                              ) + valueSuffix,
                          top: adjusted[label.key],
                          chartWidth: width,
                          tooltip: label.tooltip,
                      }
                    : undefined,
        }),
        {}
    );
}
